import EditFormPage from 'modules/ui/editform/EditFormPage';
import { useParams, withRouter } from 'react-router-dom';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormFeladatsorField from '../component/EditFormFeladatsorField';
import VizsgaFeladatsorEditService from '../service/VizsgaFeladatsorEditService';

const config = data => {
	return {
		key: 'VizsgaFeladatsorEditForm',
		text: 'Vizsga',
		textKey: 'vizsga',
		service: VizsgaFeladatsorEditService,
		defaultValue: () =>
			new Promise((resolve, reject) =>
				VizsgaFeladatsorEditService.create().then(resp => {
					resp.vizsgaVizsgasor = data.vizsgaVizsgasor;
					resolve(resp);
				})
			),
		fields: [
			{
				key: 'feladatgyujtemenyId',
				text: 'Feladatgyűjtemény',
				textKey: 'feladatgyujtemenyId',
				component: EditFormSelectField,
				items: () => VizsgaFeladatsorEditService.getFeladatGyujtemenySelection(),
				required: true
			},
			{
				key: 'genParamIdList',
				text: 'Kérdés azonosítók',
				textKey: 'genParamIdList',
				component: EditFormFeladatsorField,
				visibleIf: watchers => watchers.feladatgyujtemenyId,
				workbookIdField: 'feladatgyujtemenyId',
				required: true
			}
		]
	};
};

function VizsgaFeladatsorEditForm() {
	const { vizsgaVizsgasor } = useParams();
	const myConfig = config({ vizsgaVizsgasor });
	return <EditFormPage config={myConfig} />;
}

export default withRouter(VizsgaFeladatsorEditForm);
